// extracted by mini-css-extract-plugin
export default {"iconContainer":"dbONuR","container":"pmB07S","icon":"Dw2ai5"};